import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllPromos = async (performanceId) => {
	const headers = {
		'Content-Type': 'application/json',
	};
	try {
		const response = await axios.get(
			`${API_BASE_URL}/qsp-plus/v1/promotions/${performanceId}/promotions`,
			{
				headers,
				withCredentials: true,
			},
		);
		return response.data;
	} catch (error) {
		console.error('Error getAllPromos :', error);
		return false;
	}
};
